import React from 'react'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'

function PrivacyWrapper (props) {
  const { children } = props
  return (<div className={styles.privacyWrapper}>{ children }</div>)
}

PrivacyWrapper.propTypes = {
  children: PropTypes.array,
}

export default PrivacyWrapper



// WEBPACK FOOTER //
// ./src/components/privacy_center/util/PrivacyWrapper.jsx